import React from 'react';

function StatCard({ label, value }) {
    return (
        <div className="bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 rounded-xl p-4 flex flex-col gap-1 shadow-sm">
            <p className="text-xs font-medium text-gray-400 dark:text-gray-500 uppercase tracking-wide leading-snug">{label}</p>
            <p className="text-xl font-bold text-gray-900 dark:text-gray-50 mt-0.5">{value ?? '—'}</p>
        </div>
    );
}

function Tabs({ loan }) {

    return (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
            <StatCard label="Loan Amount (GHS)" value={loan?.amountElig} />
            <StatCard label="Months of Loan" value={loan?.paymentDuration} />
            <StatCard label="Monthly Interest Rate" value={loan?.monthInterestRate} />
            <StatCard label="Scheduled Payments" value={loan?.accountInfo?.premium} />
            <StatCard label="Processing Fee (GHS)" value={loan?.accountInfo?.processingFee} />
            <StatCard label="Insurance Fee (GHS)" value={loan?.accountInfo?.insuranceFee} />
            <StatCard label="Interest Charges (GHS)" value={loan?.accountInfo?.sumInterest} />
            <StatCard label="Amount Received (GHS)" value={loan?.accountInfo?.amountGiven} />
            <StatCard label="Payment Frequency" value={loan?.paymentPlan} />
            <StatCard label="Total Payments" value={loan?.accountInfo?.totalPayment} />
            <StatCard label="Number of Payments" value={loan?.accountInfo?.numPayments} />

            {(loan?.type === "Pension" && (loan?.loanKind !== "metropolitan" || loan?.loanKind !== "axis" || loan?.loanKind === "oldMutual")) && (
                <>
                <StatCard label="Interest per Month" value={loan?.accountInfo?.petraInterestPM} />
                <StatCard label="Commission per Month" value={loan?.accountInfo?.petraCommPM} />
                <StatCard label="Commission Total" value={loan?.accountInfo?.petraCommTotal} />
                </>
            )}

            {loan?.loanKind === "metropolitan" && (
                <StatCard label="Commission on Processing Fee (Metropolitan)" value={loan?.accountInfo?.metroProcessingFee} />
            )}
            {loan?.loanKind === "axis" && (
                <StatCard label="Commission on Processing Fee (Axis)" value={loan?.accountInfo?.axisProcessingFee} />
            )}
            {loan?.loanKind === "oldMutual" && (
                <StatCard label="Commission on Processing Fee (Old Mutual)" value={loan?.accountInfo?.oldMutualProcessingFee} />
            )}
            {loan?.loanKind === "kimpton" && (
                <StatCard label="Commission on Processing Fee (Kimpton)" value={loan?.accountInfo?.kimptonProcessingFee} />
            )}
            {(loan?.type === "Pension" && loan?.loanKind === "Petra") && (
                <>
                <StatCard label="Petra Processing (Upfront)" value={loan?.accountInfo?.petraUpfrontProcessingFee} />
                <StatCard label="Petra Processing (Spread)" value={loan?.accountInfo?.petraSpreadProcessingFee} />
                <StatCard label="CedisPay Processing" value={loan?.accountInfo?.cedisPayProcessingFee} />
                </>
            )}
        </div>
    );
}

export default Tabs;
